<div class="d-flex flex-column justify-content-center align-items-center h-100">
  <div class="background-coin">
    <div class="d-flex justify-content-center align-items-center background-color radius-minus">
      <span class="icon-coin"></span>
      <span class="coin-value">{{ balance }}<span class="coin-title">سکه</span></span>
    </div>
  </div>
  <span class="description c-2 text-align-center pt-pony">در پی‌کلاب، سکه‌هات رو پی‌درپی تبدیــــل به کد تخفیـــــــف کــــــــن</span>
</div>
